import { remoteConfig } from '@/lib/firebase';
import { RemoteConfigDatasource } from '../data/datasources/remote-config.datasource';
import { MaintenanceRepositoryImpl } from '../data/repositories/maintenance.repository.impl';

const remoteConfigDatasource = new RemoteConfigDatasource(remoteConfig);
const repository = new MaintenanceRepositoryImpl(remoteConfigDatasource);

export const maintenanceContainer = { repository };
